@if (possibleAnswers.length > 0) {
  <bt-modal [config]="qualifyingQuestionModal">
    <div class="flex flex-col gap-20px pb-24px" body>
      <p class="font-text font-normal text-14 leading-5 text-black">Tell us what you're trying to improve in your
      Microsoft 365 environment so we can guide your setup.</p>
      <div>
        @for (answer of possibleAnswers; track answer) {
          <bt-checkbox [config]="answer"></bt-checkbox>
        }
      </div>
    </div>
    <div class="w-full flex items-center justify-end" footer>
      <button class="btn-primary" [disabled]="!isAnyAnswerSelected()" (click)="saveQualifyingQuestion()">Done</button>
    </div>
  </bt-modal>
}